import axios, { AxiosResponse } from 'axios'
import { ID, WoosatTelecomResponse, Response } from '../../../../../_metronic/helpers'
import { GroupDiscount, GroupDiscountsQueryResponse } from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const GROUPDISCOUNT_URL = `${API_URL}/admin/group-discounts`
const GET_GROUPDISCOUNTS_URL = `${API_URL}/admin/group-discounts`

const getGroupDiscounts = (query: string): Promise<GroupDiscountsQueryResponse | WoosatTelecomResponse<GroupDiscount[]>> => {
  return axios
    .get(`${GET_GROUPDISCOUNTS_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<GroupDiscount[]>>) => {
      return d.data
    })
}

const getGroupDiscountById = async (id: ID): Promise<GroupDiscount> => {
  try {
    const { data } = await axios.get(`${GROUPDISCOUNT_URL}/${id}`)
    return data?.data?.group_discount
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
}

const createGroupDiscount = (groupdiscount: GroupDiscount): Promise<GroupDiscount | undefined> => {
  const formData = new FormData()
  Object.entries(groupdiscount).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, value.toString())
    }
  })

  return axios
    .post(GROUPDISCOUNT_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<GroupDiscount>) => response.data)
}

const updateGroupDiscount = (groupdiscount: GroupDiscount): Promise<GroupDiscount | undefined> => {
  const newFormData = new FormData()
  Object.entries(groupdiscount).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      newFormData.append(key, value.toString())
    }
  })

  return axios
    .post(`${GROUPDISCOUNT_URL}/${groupdiscount.id}`, newFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<GroupDiscount>) => response.data)
}

const deleteGroupDiscount = (groupdiscountId: ID): Promise<void> => {
  return axios.delete(`${GROUPDISCOUNT_URL}/${groupdiscountId}`).then((response) => {
    if (response.data.success === true) {
      toast.success(response?.data?.message, { position: 'top-right' })
    } else {
      toast.error(response?.data?.message, { position: 'top-right' })
    }
  })
}

const deleteSelectedGroupDiscounts = (groupdiscountIds: Array<ID>): Promise<void> => {
  const requests = groupdiscountIds.map((id) => axios.delete(`${GROUPDISCOUNT_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getGroupDiscounts,
  deleteGroupDiscount,
  deleteSelectedGroupDiscounts,
  getGroupDiscountById,
  createGroupDiscount,
  updateGroupDiscount,
}
